export default __webpack_public_path__ + "static/media/xingai.cf7fcc74.png";